import '../styles/home.css'
import {Message} from '../components/Message';
import {ChatListItem} from "../components/chatListItem";
import {useEffect, useRef, useState} from "react";
import * as toolbox from '../toolbox'
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const username = toolbox.getUserFromSession();
    const connection = useRef(null);
    const [chats, setChats] = useState([]);
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();
    const [userMessage, setUserMessage] = useState("");
    const [chatSearch, setChatSearch] = useState("");
    const [windowFocused, setWindowFocused] = useState(false);
    const windowFocusedRef = useRef(windowFocused);
    const userMessageRef = useRef(userMessage);

    const scrollContainerRef = useRef(null);
    const chatSearchRef = useRef(null);

    const chatsRef = useRef(chats);

    const [selectedChat, setSelectedChat] = useState("");
    useEffect(() => {
        chatsRef.current = chats;
    }, [chats, selectedChat]);
    useEffect(() => {
        document.getElementsByTagName("html")[0].scrollTop = document.getElementsByTagName("html")[0].scrollHeight;
    }, [selectedChat]);

    useEffect(() => {
        console.log("rereder-------------------------------!");

        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    });

    useEffect(() => {
        window.addEventListener("focus", ()=>{
            setWindowFocused(true);
            setMessageSeen();
        });
    }, []);

    useEffect(() => {
        connection.current = new WebSocket("wss://chatwavebackend2.cloudandcode.de")

        // Connection opened
        connection.current.addEventListener("open", (event) => {
            let token = toolbox.getJWT();
            if( token === "" ){
                navigate('/login');
            }

            let tokenJson = {};
            tokenJson["sender"] = toolbox.getUserFromSession();
            tokenJson["recipient"] = "server";
            tokenJson["token"] = token;
            tokenJson["type"] = "token";

            connection.current.send(JSON.stringify(tokenJson));
        })

        const interval = setInterval(() => {
            if (connection.current.readyState === WebSocket.OPEN) {
                connection.current.send("ping");
            }
        }, 3000);

        // Listen for messages
        connection.current.addEventListener("message", (event) => {
            let json = JSON.parse(event.data);console.log(json);
            if( json.type === "verify" ) {
                setValidated(true);
                connection.current.send("{\n" +
                    "        sender: \""+username+"\",\n" +
                    "        recipient: \"server\",\n" +
                    "        type: \"chats\",\n" +
                    "}");
            }else if(json.type === "error" && !validated) {
                connection.current.close();
                alert(json.message);
                navigate('/login');
            }else if( json.type === "message" ){
                handleIncommingMessage(json);
            }else if( json.type === "chats" ){
                if( json.chats === undefined ){
                    console.log("empty chatlist sended by api");
                }else{
                    setChatsWithSorting(json.chats);
                }
            }else if( json.type === "roulette" ){
                handleRoulettePartner(json.chatpartner);
            }else if( json.type === "error" ){
                console.log("server-error:");
                console.log(json.message);
            }
        })

        connection.current.onClose = ( event ) =>{
            navigate('/login');
        };

        connection.current.onError = ( event ) =>{
            navigate('/login');
        }

        const wsCurrent = connection.current;

        return () => {
            wsCurrent.close();
        };
    }, [])

    const getChatindexByUsername = (username) => {
        return chatsRef.current.findIndex(obj => obj.chatPartner === username);
    }

    const getCurrentChat = () => {
        return chatsRef.current[getChatindexByUsername(selectedChat)];
    }

    const setMessageSeen = ()=>{
        if( getCurrentChat()?.unseen > 0 ){
            const copy = [...chatsRef.current];
            copy[getChatindexByUsername(selectedChat)].unseen = 0;
            setChats(copy);
        }

    }

    const handleIncommingMessage = (message) => {
        const copy = [...chatsRef.current];
        if( copy.length > 0 ){
            copy[getChatindexByUsername(message.sender)]?.chat.push(message);
            if( windowFocusedRef.current === false ){
                if( copy[getChatindexByUsername(message.sender)].unseen === undefined )
                    copy[getChatindexByUsername(message.sender)].unseen = 1;
                else
                    copy[getChatindexByUsername(message.sender)].unseen += 1;
                console.log(copy[getChatindexByUsername(message.sender)]);
            }

            setChatsWithSorting(copy);
        }else{
            console.log("empty chatlist");
        }
    }

    const handleRoulettePartner = (partner) => {
        // gleicher Chat wie ausgewählt?
        if( chatsRef.current[getChatindexByUsername(selectedChat)]?.chatPartner === partner ){
            alert("Du Glückspilz! Du hast deinen aktuellen Chat gezogen. Es passiert nichts. Versuche es noch einmal :)");
            return;
        }

        // chat bereits vorhanden?
        let chatAlreadyExists = false;
        let foundPartner = "";
        for( const index in chatsRef.current ){
            if( chatsRef.current[index].chatPartner === partner ){
                chatAlreadyExists = true;
                foundPartner = chatsRef.current[index].chatPartner;
                break;
            }
        }

        if(chatAlreadyExists){
            setSelectedChat(foundPartner);
            alert("Du hast einen bereits bekannten Chat gezogen. Du kannst es noch einmal probieren.");
        }else{
            let chat = {}
            chat.chatPartner = partner;
            chat.chat = [];

            let chatCopy = [...chatsRef.current]
            chatCopy.push(chat);

            setChatsWithSorting(chatCopy);
            setSelectedChat(chatCopy.length-1);
        }
    }

    const setChatsWithSorting = (chatCopy) => {
        console.log("sort");
        chatCopy = chatCopy.sort((a,b)=>{
            return b.chat?.slice(-1)[0]?.timestamp - a.chat?.slice(-1)[0]?.timestamp;
        });
        setChats(chatCopy);
    }

    const sendMessage = () => {
        if( userMessageRef.current === "" ){
            return;
        }

        let message = {};
        message.sender = username;
        message.recipient = chatsRef.current[getChatindexByUsername(selectedChat)]?.chatPartner;
        message.type = "message";
        message.content = userMessageRef.current;
        message.timestamp = Math.round(Date.now()/1000);
        setUserMessage("");

        connection.current.send(JSON.stringify(message));

        const copy = [...chatsRef.current];
        copy[getChatindexByUsername(selectedChat)]?.chat.push(message);
        setChatsWithSorting(copy);
    };

    return (

        <main>
            {/*left container*/}
            <div style={selectedChat!==""? {} : {maxWidth: "none", width: "100%" }}>
                <div id={"container-appContent"}>
                    <div>
                        <button onClick={() => {
                            let message = {};
                            message.sender = username;
                            message.recipient = "server";
                            message.type = "roulette";
                            connection.current.send(JSON.stringify(message));
                        }}>
                            <span>Meet someone</span>
                            <img src={process.env.PUBLIC_URL + '/dice-cube.png'} alt={""}/>
                        </button>
                    </div>
                    <div>
                        <span>Chats</span>
                        <div>
                            <img src={process.env.PUBLIC_URL + '/search.png'} alt={""}/>
                            <input type={"text"} ref={chatSearchRef} onChange={(e)=>{
                                setChatSearch(e.target.value);
                            }}/>
                        </div>
                    </div>
                    <div id={"container-chatList"}>
                        {chats.map((chat, index) => {
                            let lastChatMessage = chat.chat?.slice(-1)[0];
                            let timeString = toolbox.getTimeString(lastChatMessage?.timestamp);
                            let trimmedMessage = toolbox.trimChatLastMessage(lastChatMessage?.content);

                            let isVisible = true;
                            if( chatSearchRef.current.value !== "" && !chat.chatPartner.includes(chatSearchRef.current.value) ){
                                isVisible = false;
                            }

                            index=index+Date.now();

                            let active = chat.chatPartner === selectedChat;
                            if( active ){
                                console.log("selected user: "+selectedChat);
                                console.log("user on index: "+chat.chatPartner);
                            }
                            // Problem: Irgendwo wird ein Object gerendert
                            return(
                                <ChatListItem clickCallback={()=>{
                                    setSelectedChat(chat.chatPartner);
                                    document.getElementsByTagName("html")[0].scrollTop = document.getElementsByTagName("html")[0].scrollHeight;
                                    setMessageSeen();}}
                                              trimmedLastMessage={trimmedMessage}
                                              timeStampAsString={timeString}
                                              chatPartner={chat.chatPartner}
                                              active={ active }
                                              key={index}
                                              isVisible={isVisible}
                                              unseen={chat.unseen}/>
                            );
                        })}
                    </div>
                </div>
                <div id={"container-logout"}>
                    <button onClick={() => {
                        connection.current.close();

                        navigate('/login');
                    }}>Logout
                    </button>
                </div>
            </div>
            {/*right container*/}
            <div style={{display: selectedChat===""? "none":""}}>
                <div id={"container-rightSide"}>
                <div id={"container-contactInfo"} onClick={()=>{
                    document.getElementsByTagName("html")[0].scrollTop = -document.getElementsByTagName("html")[0].scrollHeight;
                }}>
                        <div>
                            <img src={process.env.PUBLIC_URL + '/profile-picture.png'} alt={""} />
                        </div>
                        <div>
                            <span>{chats[getChatindexByUsername(selectedChat)]?.chatPartner}</span>
                        </div>
                    </div>
                    <div id={"container-chat"} ref={scrollContainerRef}>
                        {chats[getChatindexByUsername(selectedChat)]?.chat?.map((message, index) => {
                            let messageData = {};
                            messageData.content = message.content;
                            messageData.timestamp = toolbox.getTimeString(message.timestamp);

                            if (message.recipient === username)
                                messageData.messageRole = "sender";
                            else
                                messageData.messageRole = "recipient";

                            return (
                                <Message data={messageData} key={index}/>
                            );
                        })}
                    </div>
                </div>
                <div id={"container-messageInput"}>
                    <textarea id={"input-messageInput"} placeholder={"type a message"} value={userMessage}
                        onChange={(e) => {
                            // State aktualisieren
                            setUserMessage(e.target.value);
                            userMessageRef.current = e.target.value;

                            let text = e.target.value;
                            let occurs = 0;

                            for( let index = 0; index !== -1; index = text.indexOf("\n", index) ) {
                                    occurs += 1;
                                    index++;
                            }

                            if( occurs > 2 ) {
                                e.target.style.height = "100px";
                            }else {
                                e.target.style.height = "";
                            }
                        }}
                        onKeyDown={(e) => {
                            // Nur Enter ohne Shift → Nachricht senden
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                if (userMessage.trim() === "") return;
                                sendMessage();
                            }
                        }}
                    ></textarea>
                    <button id={"btn-sendMessage"} onClick={sendMessage}>Send message</button>
                </div>
            </div>
            {/*<h2>Home Page</h2>*/}
            {/*data ? <pre>{JSON.stringify(data, null, 2)}</pre> : <p>Loading...</p>*/}
        </main>
    );
};

export default HomePage;
